/* eslint-disable react-hooks/exhaustive-deps */

import CashDiscount from "../../components/CashDiscount";

const AdminCashDiscount = (props) => {
    return (
        <CashDiscount moduleType={'Admin'} {...props} />
    )
}

export default AdminCashDiscount